import { getMessages } from '../../../../../../../../store/constants';

export const TIME_AT = getMessages().getText('common.time.at');
